import React, { Fragment, useEffect, useLayoutEffect } from 'react';
import { hot } from 'react-hot-loader/root';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
// Pages
import { useSelector } from 'react-redux';
import PageNotFound from './components/404';
import ReportPDF from './components/common/PDF';
import StudentCard from './components/common/StudentCard';
import Dashboard from './containers/Dashboard';
import Login from './containers/Login';
import Register from './containers/Signup';
import { generateAuthTokens, isUserAuthenticated } from './utils';

const App = () => {
    const { user } = useSelector((state) => state.authReducer);
    const { pathname } = useLocation();
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const callGenerateAuthTokens = async () => {
            const accessToken = window.localStorage.getItem('token');
            const refreshToken = window.localStorage.getItem('refresh');
            if (user && accessToken && refreshToken) {
                const { access_token, refresh_token } = await generateAuthTokens(
                    accessToken,
                    refreshToken,
                );
                if (!access_token || !refresh_token) return;
                localStorage.setItem('token', access_token);
                localStorage.setItem('refresh', refresh_token);
                return;
            }
        };
        const intervalId = setInterval(callGenerateAuthTokens, 90 * 60 * 1000); // 90 minutes in milliseconds
        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, []);
    useEffect(() => isUserAuthenticated(user, pathname), [user, pathname]);
    const PrivateRoute = ({ element }) => (user ? element : <Navigate to='/login' />);

    return (
        <div className='App'>
            <Fragment>
                <Routes>
                    <Route exact path='/login' element={<Login />} />
                    <Route exact path='/register' element={<Register />} />
                    <Route element={<PrivateRoute element={<Outlet />} />}>
                        <Route path='/dashboard/*' element={<Dashboard />} />
                        <Route path='/record/pdf' element={<ReportPDF />} />
                        <Route path='/record/student-card' element={<StudentCard />} />
                    </Route>
                    <Route path='*' element={<PageNotFound />} />
                </Routes>
            </Fragment>
        </div>
    );
};

export default process.env.REACT_APP_ENV === 'development' ? hot(App) : App;
